/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Order/Content/TrackingId/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let orderTrackingIdValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'tracking_id',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let orderTrackingIdValueData1 = fromData.useDataValue({ viewPath,
context: 'order',
path: 'tracking_id',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 color={dtColorsNeutral700}
 text="·"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 text="Tracking ID"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral700}
 data="order.tracking_id"
 text={orderTrackingIdValueData}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 data="order.tracking_id"
 value={orderTrackingIdValueData1}
 text="Copy tracking ID"
/>
</div>
{children}
</React.Fragment>)
}